module.exports = __webpack_public_path__ + "img/menu-shezhi.5e8287d7.svg";